export default function hasClass(element, classNAME) {
  return element.classList.contains(classNAME);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/shorter-js/src/class/hasClass.js
// module id = 0
// module chunks = 0